/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Drawer, DrawerCloseButton, DrawerContent, DrawerSidebar } from '@atlaskit/drawer/compiled';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import DrawerIllustration from '../../assets/DrawerIllustration.svg';
import { InvitePeopleWithAnalytics } from '../InvitePeople';
import { type InvitePeopleDrawerProps, TestId } from './types';
import ZIndexSetter from './ZIndexSetter';

const styles = cssMap({
	wrapper: {
		display: 'inline-flex',
		alignContent: 'center',
		justifyContent: 'center',
		alignSelf: 'center',
		width: '100%',
	},
	leftContentWrapper: {
		flex: '1 1 auto',
		height: '100%',
		maxHeight: '560px',
		maxWidth: '543px',
		alignSelf: 'center',
		marginRight: token('space.1000', '80px'),
		marginTop: token('space.500', '40px'),
	},
	rightContentWrapper: {
		display: 'inline-flex',
		flex: '1 1 auto',
		maxWidth: '543px',
		alignSelf: 'flex-start',
		marginTop: token('space.1000', '80px'),
	},
	inviteWrapper: {
		minWidth: '402px',
		borderRadius: token('border.radius.100', '4px'),
		boxShadow: token(
			'elevation.shadow.raised',
			'0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)',
		),
		boxSizing: 'border-box',
	},
});

const InvitePeopleDrawer = ({
	isOpen,
	onCloseHandler,
	...invitePeopleProps
}: InvitePeopleDrawerProps) => {
	return (
		<Drawer
			onClose={onCloseHandler}
			isOpen={isOpen}
			testId={TestId.InvitePeopleDrawer}
			width="full"
		>
			<DrawerSidebar>
				<DrawerCloseButton
					// TODO: Drawer support for new icons - https://product-fabric.atlassian.net/browse/DSP-19527
					icon={() => <CrossIcon label="close" color="currentColor" spacing="spacious" />}
				/>
			</DrawerSidebar>
			<DrawerContent>
				<ZIndexSetter />
				<Box testId={TestId.InvitePeopleDrawerContent} xcss={styles.wrapper}>
					<Box testId={TestId.InvitePeopleDrawerImage} xcss={styles.leftContentWrapper}>
						<img alt="drawer-illustration" src={DrawerIllustration} />
					</Box>
					<Box xcss={styles.rightContentWrapper}>
						<Box backgroundColor="elevation.surface.raised" xcss={styles.inviteWrapper}>
							<InvitePeopleWithAnalytics
								onSendHandler={onCloseHandler}
								onCancelHandler={onCloseHandler}
								{...invitePeopleProps}
								viewAs="drawer"
							/>
						</Box>
					</Box>
				</Box>
			</DrawerContent>
		</Drawer>
	);
};

export default InvitePeopleDrawer;
